import * as Yup from 'yup';

import { NumberConstraintEnum, ResolvableModeEnum } from '@e-socna/data-layer';
import { isDefined } from '@e-socna/utils';

export const useResolvableFloatSchema = (
  numberConstraint: NumberConstraintEnum,
) => {
  const ValueSchema =
    numberConstraint === NumberConstraintEnum.Positive
      ? Yup.number()
          .optional()
          .nullable()
          .moreThan(0, 'La valeur doit être supérieure à 0')
      : numberConstraint === NumberConstraintEnum.NonNegative
        ? Yup.number()
            .optional()
            .nullable()
            .min(0, 'La valeur doit être supérieure ou égale à 0')
        : Yup.number().optional().nullable();

  const ResolvableFloatSchema = Yup.object()
    .shape({
      mode: Yup.mixed<ResolvableModeEnum>()
        .oneOf(Object.values(ResolvableModeEnum))
        .required('Le mode est requis'),
      resolverId: Yup.string().optional().nullable(),
      value: ValueSchema,
    })
    .test({
      name: 'is-valid',
      // eslint-disable-next-line object-shorthand
      test: function (values) {
        if (
          (values.mode === ResolvableModeEnum.Static &&
            isDefined(values.value) &&
            !isDefined(values.resolverId)) ||
          (values.mode === ResolvableModeEnum.Dynamic &&
            !isDefined(values.value) &&
            isDefined(values.resolverId))
        ) {
          return true;
        }

        return this.createError({
          message:
            'Veuillez sélectionner un mode et fournir une valeur ou un résolveur valide.',
        });
      },
    });

  return ResolvableFloatSchema;
};
